import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationArrow } from "@fortawesome/free-solid-svg-icons";

const getGpsIcon = (condition) => (
    <FontAwesomeIcon
        icon={faLocationArrow}
        className={condition && condition.gps ? "text-success" : "text-danger"}
    />
);

export default getGpsIcon;



// WEBPACK FOOTER //
// ./src/views/pages/bikes/helpers/get-gps-icon.js